App.namespace.wrap('es6.views.venue.maps_callback', function () {
  // Places Autocomplete
  App.es6.shared.google_places_manager({
    getGoogleApi: false,
  }).init();

  // Street View and Map
  App.views.venue.location_venue_page();
});
